// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Reports (admin) — dossier / register / platform volume.
 * Tables → cards handled by enterprise.css (.pro-table @ <=576px).
 */
.ent.reports-page { padding: 24px; }
.ent.reports-page .filter-tabs { margin: 16px 0 14px; }
.ent.reports-page .kpi-strip { margin: 16px 0; }
.ent.reports-page .pro-table-wrap { margin-bottom: 0; }

.ent.reports-page .reports-merchant-bar {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.ent.reports-page .reports-merchant-bar label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.72rem;
  color: var(--ent-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.ent.reports-page .reports-merchant-bar input {
  min-width: 220px;
  min-height: 38px;
  padding: 0.5rem 0.625rem;
  border: 1px solid var(--ent-border-strong);
  border-radius: 8px;
  background: var(--ent-card-alt);
  color: var(--ent-text);
  font-size: 0.85rem;
  text-transform: none;
  letter-spacing: normal;
}
.ent.reports-page .reports-merchant-bar input:focus { outline: none; border-color: var(--ent-primary); }

.ent.reports-page .reports-range {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
}

.ent.reports-page .reports-panel {
  background: var(--ent-card);
  border: 1px solid var(--ent-border);
  border-radius: var(--ent-radius);
  box-shadow: var(--sh-card);
  padding: 16px 18px;
  margin-bottom: 16px;
}
.ent.reports-page .reports-panel__title {
  font-size: 13px;
  font-weight: 700;
  color: var(--ent-text);
  margin-bottom: 12px;
}

.ent.reports-page .reports-kv {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}
.ent.reports-page .reports-kv > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ent.reports-page .reports-kv span {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ent-muted);
}
.ent.reports-page .reports-kv strong { font-size: 0.9rem; color: var(--ent-text); font-weight: 600; }

.ent.reports-page .reports-charts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.ent.reports-page .reports-charts.mobile { grid-template-columns: 1fr; }

.ent.reports-page .reports-empty-chart {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ent-muted);
  font-size: 14px;
}

.ent.reports-page .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: var(--ent-muted);
  gap: 0.25rem;
}
.ent.reports-page .empty-state svg { color: var(--ent-muted); margin-bottom: 0.5rem; }
.ent.reports-page .empty-state p { margin: 0; font-weight: 600; color: var(--ent-text); }

@media (max-width: 768px) {
  .ent.reports-page { padding: 16px; }
  .ent.reports-page .reports-charts { grid-template-columns: 1fr; }
  .ent.reports-page .reports-kv { grid-template-columns: 1fr; }
  .ent.reports-page .reports-merchant-bar input { min-width: 0; width: 100%; }
  .ent.reports-page .reports-merchant-bar label { flex: 1 1 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Reports.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF,oBAAoB,aAAa,EAAE;AACnC,iCAAiC,mBAAmB,EAAE;AACtD,+BAA+B,cAAc,EAAE;AAC/C,oCAAoC,gBAAgB,EAAE;;AAEtD;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA,sDAAsD,aAAa,EAAE,gCAAgC,EAAE;;AAEvG;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;AACA,uCAAuC,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAEpG;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA,2CAA2C,0BAA0B,EAAE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA,qCAAqC,uBAAuB,EAAE,qBAAqB,EAAE;AACrF,mCAAmC,SAAS,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAExF;EACE,oBAAoB,aAAa,EAAE;EACnC,oCAAoC,0BAA0B,EAAE;EAChE,gCAAgC,0BAA0B,EAAE;EAC5D,gDAAgD,YAAY,EAAE,WAAW,EAAE;EAC3E,gDAAgD,cAAc,EAAE;AAClE","sourcesContent":["/*\n * Reports (admin) — dossier / register / platform volume.\n * Tables → cards handled by enterprise.css (.pro-table @ <=576px).\n */\n.ent.reports-page { padding: 24px; }\n.ent.reports-page .filter-tabs { margin: 16px 0 14px; }\n.ent.reports-page .kpi-strip { margin: 16px 0; }\n.ent.reports-page .pro-table-wrap { margin-bottom: 0; }\n\n.ent.reports-page .reports-merchant-bar {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n.ent.reports-page .reports-merchant-bar label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 0.72rem;\n  color: var(--ent-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.ent.reports-page .reports-merchant-bar input {\n  min-width: 220px;\n  min-height: 38px;\n  padding: 0.5rem 0.625rem;\n  border: 1px solid var(--ent-border-strong);\n  border-radius: 8px;\n  background: var(--ent-card-alt);\n  color: var(--ent-text);\n  font-size: 0.85rem;\n  text-transform: none;\n  letter-spacing: normal;\n}\n.ent.reports-page .reports-merchant-bar input:focus { outline: none; border-color: var(--ent-primary); }\n\n.ent.reports-page .reports-range {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.ent.reports-page .reports-panel {\n  background: var(--ent-card);\n  border: 1px solid var(--ent-border);\n  border-radius: var(--ent-radius);\n  box-shadow: var(--sh-card);\n  padding: 16px 18px;\n  margin-bottom: 16px;\n}\n.ent.reports-page .reports-panel__title {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--ent-text);\n  margin-bottom: 12px;\n}\n\n.ent.reports-page .reports-kv {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 14px;\n}\n.ent.reports-page .reports-kv > div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.ent.reports-page .reports-kv span {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--ent-muted);\n}\n.ent.reports-page .reports-kv strong { font-size: 0.9rem; color: var(--ent-text); font-weight: 600; }\n\n.ent.reports-page .reports-charts {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n.ent.reports-page .reports-charts.mobile { grid-template-columns: 1fr; }\n\n.ent.reports-page .reports-empty-chart {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ent-muted);\n  font-size: 14px;\n}\n\n.ent.reports-page .empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: var(--ent-muted);\n  gap: 0.25rem;\n}\n.ent.reports-page .empty-state svg { color: var(--ent-muted); margin-bottom: 0.5rem; }\n.ent.reports-page .empty-state p { margin: 0; font-weight: 600; color: var(--ent-text); }\n\n@media (max-width: 768px) {\n  .ent.reports-page { padding: 16px; }\n  .ent.reports-page .reports-charts { grid-template-columns: 1fr; }\n  .ent.reports-page .reports-kv { grid-template-columns: 1fr; }\n  .ent.reports-page .reports-merchant-bar input { min-width: 0; width: 100%; }\n  .ent.reports-page .reports-merchant-bar label { flex: 1 1 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
